/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/ClientSide/javascript.js to edit this template
 */


import { useState, useEffect }
    from "react";
import { useParams, useLocation }
    from 'react-router-dom';

import { Container, Row, Col, Tab, Nav }
    from 'react-bootstrap';
import { library }
    from '@fortawesome/fontawesome-svg-core';
import { fas }
    from '@fortawesome/free-solid-svg-icons';
import { fab }
    from '@fortawesome/free-brands-svg-icons';
import { far }
    from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon }
    from '@fortawesome/react-fontawesome';

library.add(fas, fab, far);
function PrivacyPolicy() {

    return (
        <div>
            <Row><h2>Privacy Policy</h2></Row>
            <br />
            <Row>
                <p>
                    <b>Privacy Policy – Your Data, Our Responsibility</b><br />
                    Welcome to Grace Daily, the official online platform of Grace Super Market. Your privacy is important to us, and we’re committed to protecting it. This Privacy Policy explains how we collect, use, and safeguard your personal information when you interact with our site.
                    By using our website, you agree to the practices outlined below.
                    <br /><br />

                    <b>What We Collect</b><br />
                    When you register or browse our site, we may collect:<br />
                    •	Your name, email, mobile number, and address<br />
                    •	Demographics like age, gender, occupation, and education<br />
                    •	Your activity on the site — pages visited, links clicked, time spent, etc.<br /><br />

                    <b>How We Collect It</b><br />
                    Your information is collected when you:<br />
                    •	Sign up or fill out a form<br />
                    •	Take a survey<br />
                    •	Interact with our website using cookies (e.g., Google Analytics, DoubleClick)<br />
                    Note: External sites we link to may have different privacy policies — we’re not responsible for them.<br /><br />


                    <b>How We Use Your Info</b><br />
                    We use your data to:<br />
                    •	Personalize your shopping experience<br />
                    •	Share offers and promotions tailored to you<br />
                    •	Improve our products and services<br />
                    •	Contact you for feedback, contests, or surveys<br />
                    •	Serve relevant ads via third-party platforms (like Google)<br />
                    We may also share non-personal, aggregated data with our partners to enhance your shopping experience.<br /><br />


                    <b>Your Information is Safe With Us</b><br />
                    •	We never sell or rent your personal data.<br />
                    •	We share info only with trusted partners when required to deliver services you've requested.<br />
                    •	We may disclose data if legally required (e.g., court orders, fraud investigations).<br /><br />


                    <b>Your Choices & Security</b><br />
                    •	Your data is only accessible by authorized personnel.<br />
                    •	We use industry-standard security to protect it — but remember, no online system is 100% foolproof.<br />
                    •	By using our site, you accept the minimal risks of internet-based data transmission.<br /><br />


                    <b>Update or Correct Your Info</b><br />
                    Need to make changes or recover access?<br />
                    Email us at:  <b>graceonlinesupermarket@gmail.com</b><br /><br />

                    <b>Policy updates</b><br />
                    We may update this policy from time to time. All changes will be posted here and effective immediately.<br /><br />
                    At Grace Daily, your trust fuels everything we do. Thanks for shopping with us<br /><br />

                </p>
            </Row>
        </div>

    );
}

export default PrivacyPolicy;